import { StyleColumn } from '@components/styles'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import PageBreadCrum from '../components/pageBreadCrumb'
import { fetchByKey } from '../fetch'
import AdminDefaultEditorForm from '../form'
import AdminDefaultSeoForm from '../seoForm'
const title = 'About Us'
const aboutUsPageKey = 'aboutUs'
const seoPageKey = 'aboutUsSeo'
const AdminAboutUs = () => {
  const { data: aboutUs } = useSelector((state: any) => state.aboutUs)
  const { data: seo } = useSelector((state: any) => state.aboutUsSeo)
  useEffect(() => {
    if (!aboutUs?.id) {
      fetchByKey(aboutUsPageKey)
    }
    if (!seo?.id) {
      fetchByKey(seoPageKey)
    }
  }, [])
  return (
    <StyleColumn>
      <PageBreadCrum
        title={title}
        onClick={() => {
          window.open('/#/about-us', '_blank', 'noopener,noreferrer')
        }}
      />
      <AdminDefaultEditorForm
        pageKey={aboutUsPageKey}
        title={title}
        data={aboutUs}
      />
      <AdminDefaultSeoForm
        data={seo}
        pageKey={seoPageKey}
        title={`${title} Seo`}
      />
    </StyleColumn>
  )
}
export default AdminAboutUs
